<template>
  <div class="agreement" @click="toAgreement">《Privacy Agreement》</div>
</template>

<script>
export default {
  methods: {
    toAgreement () {
      this.$router.push({ name: 'agreementPage', query: { title: 'Privacy Agreement', type: 'privacy' } })
    }
  }
}
</script>

<style scoped lang="less">
.agreement {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #BBBBBB;
  padding: 50px 0;
}
</style>
